<section class="background">
  <header>
    <h1 class="title">Vous n&apos;avez pas accès à ce Back Office</h1>
  </header>
  <svg class="image403" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 637 459">
    <path
      d="M609.51 457.99c-40.18 0-583.41-1.18-583.41-1.24-.23-.53-68.97-84.87 17.59-173.06 42.89-43.69-39.39-100.3 0-148.9C111.15 51.53 177.9 98.42 233.5 75c9.83-4.13 19.69-10.78 29.56-20.99a109.87 109.87 0 0 1 21.19-17.05 120.8 120.8 0 0 1 12.12-6.58c2.8-1.33 5.65-2.55 8.55-3.67 4.62-1.78 9.35-3.32 14.19-4.62a160.43 160.43 0 0 1 21.15-4.16c3.15-.41 6.32-.73 9.52-.97 62.13-4.68 132.06 21.63 168.14 60.07 7.27 7.74 40.3 47.8 14.26 102.86-16.44 34.76 52.44 67.96 76.92 107.66 62.23 100.93.97 169.12.4 170.44Z"
      fill="#E8E1FC"
    />
    <g opacity=".8">
      <path
        opacity=".8"
        d="M468.92 223.33a78.6 78.6 0 0 1-28.13 37.2 78.82 78.82 0 0 1-73.08 10.1 79.07 79.07 0 0 1-47.25-101.33 79.55 79.55 0 0 1 7.43-15.2l.1-.16A78.87 78.87 0 0 1 373 120.27a78.48 78.48 0 0 1 54.2 3.98 78.54 78.54 0 0 1 32.01 26.46h.01a79.37 79.37 0 0 1 14.22 51.92 79.4 79.4 0 0 1-4.53 20.7Z"
        fill="#fff"
      />
      <g opacity=".8" fill="#4B45B2">
        <path
          opacity=".8"
          d="M381.55 153.87c-4.67 3.62-3.43 13.3-11.5 7.85-8.09-5.46-13.16-8.43-15.45-3.66-2.29 4.76 4.87 7.37 2.99 12.56-1.89 5.19-5.72 5.74-9.76 1.47-4.05-4.26-4.16-8.36-10.7-8.22-6.56.13-9.35-2.56-9.03-7.49a6.97 6.97 0 0 0-.21-2.28l.1-.16A78.86 78.86 0 0 1 373 120.28a76.62 76.62 0 0 1 5.86-1.44 10.4 10.4 0 0 1 6.02 6.6c2.85 8.3 7.48 6.35 3.55 13.31-3.93 6.97-2.3 8.68 1.98 9.96 4.28 1.27 9.22 3.07 8.55 6.46-.68 3.4-12.75-4.91-17.42-1.3ZM468.92 223.33a78.59 78.59 0 0 1-28.13 37.2 9.02 9.02 0 0 1-5.87-2.32c-7.92-7.08 2.57-14.6 8.09-18.25 5.52-3.66-4.73-4.87-9.9-12-5.17-7.12 6.94-16.78-.84-17.3-7.78-.52-17.23-1.03-18.82-9.37-1.58-8.34 6.6-6.62 5.17-13.65-1.43-7.02 5.33-8.34 12.57-6.33 7.24 2 8.13-3.34 17.1-.91 8.97 2.42 4.74 13.47 14.64 16.24 9.9 2.76 8.66 4.83 8.66 4.83.7.23 1.32.62 1.85 1.15a79.24 79.24 0 0 1-4.52 20.71ZM473.03 186.11c-9.42.99-8.78-10.79-16.78-10.09-8.07.7-4.62-5.04-8.6-10.96-4-5.93-17.46-2.72-14.73-8.72 2.74-6 10.25-1.3 13.78-5.62 3.52-4.31 10.97-.2 10.97-.2.51 0 1.03.06 1.56.2a79.38 79.38 0 0 1 13.8 35.4ZM413.33 140.25s6.4-4.53.38-8.74c-6.02-4.22-6.74-1.83-11.72-4.27-4.99-2.44-8.48.83-6.19 6.64 2.3 5.8 2.39 15.36 7.53 12.15 5.15-3.2 5.7-6.85 10-5.78Z"
        />
      </g>
    </g>
    <path
      d="M44.04 456.97h27.55c1.47-1.25-1.03-4.1-3.63-4.29-1.14-.09-2.57.15-4.21.5-.38-5.04-2.54-27.7-10.7-26.8-9.18 1.03 0 9.99 2.59 15.29a125.3 125.3 0 0 1 4.87 12.22c-.74.16-1.51.32-2.3.47-1.22-3.74-5.74-16.31-11.5-15.58-6.75.86-4.04 5.9.75 8.9 3.51 2.2 7.83 5.32 9.88 6.83-1.74.29-3.55.48-5.4.43-4.7-.1-7.01 1.29-7.9 2.03ZM482.46 456.97h-25.6c-1.36-1.16.96-3.8 3.38-3.99 1.05-.07 2.38.15 3.9.47.36-4.69 2.37-25.74 9.95-24.89 8.52.95 0 9.27-2.41 14.2a117.72 117.72 0 0 0-4.53 11.35c.7.15 1.4.3 2.14.43 1.13-3.47 5.33-15.15 10.67-14.47 6.28.8 3.76 5.48-.69 8.26a166.04 166.04 0 0 0-9.17 6.35c1.61.27 3.3.45 5 .4 4.39-.1 6.53 1.2 7.36 1.9Z"
      fill="#C6D92F"
    />
    <path
      d="M500.73 289.05s.6-6.06-2.56-5.85c-3.17.2-4 1.66-3.65 2.83.35 1.16 3.44 5.02 3.44 5.02l2.77-2Z"
      fill="#FFB27D"
    />
    <path
      d="M550.09 301.2s-3.5 4.13-11.05 8.9a83.5 83.5 0 0 1-14.1 7.04c-4.52 1.63-12.84 3.94-17.99 4.15-.45.02-.87.02-1.27 0-7.84-.31-8.8-30.79-8.8-30.79s.88-3.04 4.9-2.27c0 0 6.12 17.2 8.32 18.6 1.94 1.25 13.14-15.73 22.77-16.92 6.49-.81 17.22 11.3 17.22 11.3Z"
      fill="#FC5A5A"
    />
    <path
      d="M529.02 449.8s.58 6.72-.84 7.41l-18.13-.03s0-2.1 2.92-2.56c2.9-.47 8.02-2.18 8.89-5.98.86-3.8 7.16 1.17 7.16 1.17Z"
      fill="#1C3154"
    />
    <path
      d="M515.71 368.62c.09 4.38.3 8.91.71 12.98 1.96 19.3 2.65 42.6 2.93 47.1.49 7.8 2.03 20.27 2.03 20.27s3.05 2.9 9 1.51c0 0 4.94-17.95 6.04-36.85l.05-.94.4-8.43c.9-20.64 1.89-51.3 1.89-51.3L516 347.6s-.52 10.07-.3 21Z"
      fill="#0F2A47"
    />
    <path
      d="M515.71 368.62c5.76 9.95 16.75 28.3 21.15 35.63.91-20.64 1.9-51.3 1.9-51.3L516 347.6s-.52 10.08-.3 21.02Z"
      fill="#0F2A47"
    />
    <path
      d="M524.93 317.13c-4.52 1.63-12.83 3.95-17.98 4.16.79-.15 6.53-1.29 8.65-3.85 2.27-2.76 6.11-10.25 9.16-7.19 1.44 1.44 1.02 4.28.17 6.88Z"
      fill="#EA3B3B"
    />
    <path
      d="M563.16 365.37s1.4 5.55 1.18 6.78c-.24 1.23-1.62 5.4-2.48 6.44-.86 1.03-.89-4.5-1.46-5.37-.57-.87-.26 2.06-.72 2.3-.46.25-1.23-2.22-1.56-3.1-.34-.87 1.22-3.9 1.36-6.09.15-2.18 3.68-.96 3.68-.96Z"
      fill="#FFB27D"
    />
    <path
      d="M574.17 442.18s3.23 2.95 2.6 5.04c-.63 2.1-3.54 3.5-3.93 6.05-.4 2.56-1.97 3.96-3.39 3.96h-6.75s-1.04-1.8 1.47-2.35c2.52-.54 3.47-3.55 3.32-6.34-.16-2.8.23-6.51.23-6.51l5.35-1.24 1.1 1.4Z"
      fill="#1C3154"
    />
    <path
      d="M519.6 353.42s21.29 45.6 32.62 65.62c11.33 20.01 14.87 25.6 14.87 25.6s6.5-2.56 7.08-4.3c0 0-4.33-38.64-11.92-48.06-4.28-5.32-9.32-21.3-9.56-26.88-.23-5.58-5.2-18.91-5.2-18.91l-27.9 6.93Z"
      fill="#0F2A47"
    />
    <path
      d="M515.63 351.05s6.93 7.47 18.71 9.72c5.17 1 15.67 1.95 18.27-1.73.61-.87.62-2.15.48-4.15-.35-5.2-1.66-15.25 4.24-35.45a34.3 34.3 0 0 0 1.13-5.4c1.3-10.34 1.15-18.14-7.8-22.3-13.42-6.25-18.93-1.11-18.93-1.11s-7.13 3.34-10.4 13.07c-6.51 19.46-5.7 47.35-5.7 47.35Z"
      fill="#FC5A5A"
    />
    <path
      d="M542.6 290.02a9.95 9.95 0 0 1-10.02.66c-.29-.14-.25-2.15-.18-4.12.08-1.94.26-3.83.26-3.83l4.77-3.14 4.56-3c-.55 10.3 1.63 12.7.62 13.44Z"
      fill="#FFB27D"
    />
    <path d="M541.18 280.84s-3.1 4.66-8.78 5.72c.07-1.94.28-4.07.28-4.07l4.75-2.9 3.75 1.25Z" fill="#ED985F" />
    <path
      d="M528.38 281.52s11.55 4.31 14.12-2.81c2.57-7.13 5.8-11.37-1.48-14.42-7.26-3.06-9.68-.86-11.13 1.31-1.44 2.17-4.45 14.6-1.51 15.92Z"
      fill="#FFB27D"
    />
    <path
      d="M549.7 265.08c.13-.1.4-.15.96-.07 0 0-.39-.37-.98-.5.04-.8-.1-2.25-1.37-2.84 0 0 .64.52.57 1.36-1.23-1.89-4.3-3.7-13.6-4.78-12.24-1.43-9.79 7.08-8.4 8.31 1.37 1.23 5.8-.52 8.66.29 2.86.8 2.59 5.12 3.46 5.9.87.76.68-.33 2.14-.67 1.45-.34 1.14 1.9.47 3.26-.67 1.36.79 3.63.79 3.63l2.25-1.64c2.25-1.63 5.66-9.75 5.18-11.72-.05-.17-.1-.35-.13-.53Z"
      fill="#0F2A47"
    />
    <path
      d="M553.1 354.89c-.36-5.2-1.66-15.25 4.23-35.45.55-1.88.92-3.68 1.14-5.4-4.38-1.45-12.37 1.77-12.37 1.77s-1.88 26.7 7 39.08Z"
      fill="#EA3B3B"
    />
    <path
      d="M553.07 293.09s5.4 1.96 8.83 16.25c2.28 9.45 6.46 23.33 6.93 27.69.47 4.36-4.78 29.9-4.78 29.9s-.74.53-2.56.17c-1.74-.35-2.54-1.53-2.54-1.53s-1.26-17.01-.94-25.05c.14-3.34-15.43-24.45-23.84-27.17-3.3-1.07 18.9-20.26 18.9-20.26Z"
      fill="#FC5A5A"
    />
    <path d="M477.66 274.59s15.58-.44 33.57 2.87l1.88-4.74 2.06-5.2s-18.05-7.77-28.9-18.6l-8.6 25.67Z" fill="#AEC3FF" />
    <path
      d="m486.5 248.66-8.94 26.44a2.38 2.38 0 0 1-1.57-3.08l7.88-22.22a1.97 1.97 0 0 1 2.64-1.14ZM495.05 294.27c1.74.35 3.44-.8 3.8-2.53l3.07-15.44a3.24 3.24 0 0 0-2.53-3.8 3.24 3.24 0 0 0-3.8 2.54l-3.07 15.43a3.24 3.24 0 0 0 2.53 3.8Z"
      fill="#FC5A5A"
    />
    <path d="M477.66 274.59s15.58-.44 33.57 2.87l1.88-4.74c-16.9-3.45-35.45 1.87-35.45 1.87Z" fill="#739AF0" />
    <path
      d="m506.25 276.5 4.88.87c-.08 0 4.52.9 6.02-3.19.14-.28.23-.55.3-.88 1.17-5.08-1.62-6.02-1.62-6.02l-6.27-2.44-1.99 7.05v.03l-1.31 4.59Z"
      fill="#FC5A5A"
    />
    <path d="m506.25 276.5 4.88.87c-.08 0 4.52.9 6.02-3.19-2.75-2-9.58-2.3-9.58-2.3v.03l-1.31 4.6Z" fill="#EA3B3B" />
    <path
      d="M495.46 279.33s2.39.95 1.95 2c-.44 1.05-3.47 2.5-3.95 1.66-.47-.82.5-4.55 2-3.66ZM500.77 288.1s.46-2.44.48-3.56c.03-1.13.16-2.04-.1-2.07-.26-.04-.46.17-.56.53-.11.36-.52 2.6-.52 2.6l.2 2.15.5.35Z"
      fill="#FFB27D"
    />
    <path
      d="m265.17 286.5-13.5 160.66s-1.4 9.73 5.83 9.75c11.9.03 59.2 0 59.2 0s-8.94-2.03-8.84-6.59C308 444.95 323.64 285 323.64 285l-58.47 1.52Z"
      fill="#7599EA"
    />
    <path
      d="M321.16 454.06c-2.34.01-48.15.09-59.73-.06-5.05-.06-5.94-4.5-5.98-7.37-.02-1.37.16-2.39.16-2.39l.35-4.17.9-10.64.78-9.4 1.02-12.09.85-10.2 9.6-114.15 58.46-1.52s-6.59 66.94-11.25 115.67l-1.47 15.5-.44 4.54a8980.34 8980.34 0 0 0-1.67 18.06 338.8 338.8 0 0 0-.94 11.57c0 .46.03.9.11 1.3.96 5.12 8.37 5.35 9.25 5.35Z"
      fill="#90AFF4"
    />
    <path d="m123.18 199.09 32.87 132.2 4.5 18.1 15.31 61.57h284.45l-56.43-211.87h-280.7Z" fill="#AEC3FF" />
    <path d="m123.18 199.09-4.56 1.52 51.19 214.95 6.05-4.6-52.68-211.87Z" fill="#90AFF4" />
    <path d="M169.8 415.56h282.7l7.8-4.6H175.87l-6.05 4.6Z" fill="#7599EA" />
    <path d="M269.08 456.97h61.2v-2.91h-61.2v2.91Z" fill="#AEC3FF" />
    <path d="m314.73 415.56-.31 2.22-57.57 11.64.79-9.4.38-4.46h56.71Z" fill="#5888DD" />
    <path
      opacity=".4"
      d="M321.16 454.06c-2.34.01-48.15.09-59.73-.06-5.05-.06-5.94-4.5-5.98-7.37l57.3-10.79c-.6 6.58-.95 10.77-.96 11.57 0 .47.04.9.12 1.3.96 5.12 8.37 5.35 9.25 5.35Z"
      fill="#5888DD"
    />
    <path d="M123.18 199.09h280.7l45.54 170.27h-283.9L123.18 199.1Z" fill="#AEC3FF" />
    <path
      d="M436.18 361.99H173.36l-9.39-37.46-3.63-14.5-1.49-5.9-9.65-38.5-.5-2-5.1-20.35-2.28-9.1-1.95-7.77-4.57-18.2h259.04l5.01 18.2 2.14 7.77 2.5 9.1 16.52 59.98 1.4 5.08.65 2.36 11.4 41.41 2.72 9.88Z"
      fill="#739AF0"
    />
    <path d="M398.85 226.41H139.37l-4.56-18.2h259.03l5.01 18.2Z" fill="#607CF4" />
    <path
      d="M145.52 216.44c-.3-1.26.45-2.28 1.7-2.28a3.1 3.1 0 0 1 2.85 2.28c.3 1.25-.45 2.27-1.7 2.27a3.1 3.1 0 0 1-2.85-2.28ZM153.08 216.44c-.32-1.26.45-2.28 1.7-2.28a3.1 3.1 0 0 1 2.84 2.28c.31 1.25-.45 2.27-1.7 2.27a3.1 3.1 0 0 1-2.84-2.28ZM161.2 216.44c-.3-1.26.46-2.28 1.71-2.28a3.1 3.1 0 0 1 2.84 2.28c.31 1.25-.45 2.27-1.7 2.27a3.1 3.1 0 0 1-2.84-2.28Z"
      fill="#E9F3FE"
    />
    <path
      d="M342.31 102.36c10.62-12.49 27-37.57 38.03-50.41a4.07 4.07 0 0 0-3.1-6.72h-20.06L376.1 2.37c.81-1.83-1.68-3.28-2.88-1.68L327.45 62a2.54 2.54 0 0 0 2.34 4.04l22.72-2.8L339 100.42c-.75 2.05 1.9 3.6 3.31 1.94Z"
      fill="#0062FF"
    />
    <path
      d="M247.83 178.42c2.38-12.28 3.9-35.07 6.42-47.73a3.1 3.1 0 0 0-4.57-3.3l-13.33 7.5-3.44-35.54c-.15-1.52-2.34-1.55-2.54-.04l-7.49 57.87a1.93 1.93 0 0 0 3.06 1.8L240 148.62l4.9 29.75c.28 1.64 2.62 1.68 2.94.05Z"
      fill="#4B45B2"
    />
    <path
      d="M447.66 365.61 219.3 384.87c-17.34 1.47-29.88-16.23-22.79-32.14l96.75-216.78c7.35-16.44 29.9-18.34 39.9-3.36l131.6 197.52c9.67 14.49.25 34.04-17.09 35.5Z"
      fill="#fff"
    />
    <path
      d="m448.4 374.26-228.38 19.26a31.23 31.23 0 0 1-28.35-13.18 31.31 31.31 0 0 1-3.08-31.15l96.75-216.78a31.13 31.13 0 0 1 26.14-18.57 31.11 31.11 0 0 1 28.88 13.93L471.97 325.3a31.31 31.31 0 0 1 2.18 31.22 31.26 31.26 0 0 1-25.76 17.75ZM312.93 131.13a14 14 0 0 0-11.77 8.36l-96.75 216.78a14.1 14.1 0 0 0 1.38 14.02 14.06 14.06 0 0 0 12.77 5.93l228.37-19.26a14.07 14.07 0 0 0 11.59-7.98 14.1 14.1 0 0 0-.98-14.06L325.93 137.4a14 14 0 0 0-13-6.27Z"
      fill="#FC5A5A"
    />
    <path
      d="M307.58 332.45c-.24-2.95.05-5.72.9-8.3a19.18 19.18 0 0 1 3.9-6.88 20.5 20.5 0 0 1 6.56-4.87 25.6 25.6 0 0 1 8.99-2.3c3.38-.3 6.49-.04 9.31.76 2.83.8 5.28 2.03 7.35 3.7a19.15 19.15 0 0 1 5 6.11 20.99 20.99 0 0 1 2.27 8.04c.24 2.95-.06 5.7-.9 8.24a19.32 19.32 0 0 1-3.91 6.8c-1.77 2-3.98 3.62-6.63 4.88a26.14 26.14 0 0 1-9.06 2.31c-3.38.29-6.46.03-9.24-.77-2.78-.8-5.2-2.03-7.28-3.7a19.25 19.25 0 0 1-5-6.05 20.44 20.44 0 0 1-2.25-7.97Zm35.31-41.37-32.9 2.78-14.12-112.13 42.21-3.56 4.81 112.91Z"
      fill="#FC5A5A"
    />
    <path
      d="M165.77 297.96s.72-1.61 1.18-2.38c.47-.76 2.45-3 2.79-2.49.33.5 1.68 3.91.97 4.87-.72.96.04 2.61-3.52 3.62l-1.42-3.62Z"
      fill="#FFB27D"
    />
    <path
      d="M126.17 287.78s18.24 15.25 25.36 13.84c5.56-1.1 14.35-3.9 14.35-3.9s2.32 2.21 1.67 4.86c0 0-11.2 10.55-19.19 10.62-12.48.1-18.36-6.19-18.36-6.19l-3.83-19.23Z"
      fill="#EA3B3B"
    />
    <path
      d="M94.17 448.6s.53 8.56 2.18 8.68c.22.02 8.39.02 8.39.02l10.42-.06s-.07-2.52-3.12-3.05c-3.04-.53-8.14-2.67-9.99-6.7-1.94-4.25-7.88 1.11-7.88 1.11Z"
      fill="#113C68"
    />
    <path
      d="M93.57 449.2s3.17 1.06 5.64 1.06c2.76 0 5.27-.75 5.27-.75s.6-5.78 3.88-18.5a422.26 422.26 0 0 1 7.67-25.9c9.67-29.45 12.6-46.68 12.87-48.3l.02-.13-.03-.02-29.72-13.06s3.67 40.59-1.01 56.16a65.87 65.87 0 0 0-1.7 7.47c-2.96 16.91-2.89 41.97-2.89 41.97Z"
      fill="#0F2A47"
    />
    <path
      d="M108.36 431a422.26 422.26 0 0 1 7.67-25.9c9.67-29.44 12.6-46.67 12.87-48.3v-.14l-29.73-13.07s3.68 40.59-1.01 56.17c-.66 2.18 10.2 31.25 10.2 31.25Z"
      fill="#0F2A47"
    />
    <path
      d="M117.38 448.6s.53 8.56 2.19 8.68c.22.02 8.38.02 8.38.02l10.42-.06s-.06-2.52-3.11-3.05c-3.05-.53-8.15-2.67-10-6.7-1.94-4.25-7.88 1.11-7.88 1.11Z"
      fill="#15447C"
    />
    <path
      d="M134.23 344.55s.39 26.3-4.16 58.6c-4.54 32.29-3 46-3 46s-3.13 1-4.38 1.1c-3.21.27-6.5-.75-6.5-.75s-6.51-32.3-4.64-48.46c1.86-16.17-8.91-55.46-8.91-55.46l31.6-1.03Z"
      fill="#0F2A47"
    />
    <path
      d="m113.16 283 5.8 3.82 5.28-1.5c.97-1.38 1.23-4.04 1.24-6.34.01-2.29-.21-4.23-.21-4.23l-7.83-3.45-2.92-1.3.26 2.75c.55 6.1-1.62 10.26-1.62 10.26Z"
      fill="#FFB27D"
    />
    <path
      d="M134.37 351.86c-7.23 6.98-34.55 5.81-36.24-1.88-1.68-7.7 1.84-65.46 14.17-69.1 2.56-.74 16.25 3.68 16.25 3.68s2.15 5.63 3.55 12.79c.28 1.39 1.07 16.15 1.67 29.96.28 6.47.52 12.72.63 17.3.12 4.28.12 7.1-.03 7.25Z"
      fill="#FC5A5A"
    />
    <path
      d="M115.37 272.86c1.59 2.69 7.16 5.04 10.11 6.12.02-2.29-.2-4.23-.2-4.23l-7.84-3.45c-1.72-.03-2.78.36-2.07 1.56Z"
      fill="#FCA56B"
    />
    <path
      d="M128.23 274.28s-12.61 3.94-14.94-3.96-5.53-12.72 2.42-15.56c7.96-2.85 10.42-.3 11.84 2.15 1.41 2.44 3.9 16.14.68 17.37Z"
      fill="#FFB27D"
    />
    <path
      d="M127.05 256.14s-.8 9.2-2.7 8.8c-1.9-.4-4-1.26-3.72 1.51.28 2.78-1.84 7.53-4.58 7.51-5.87-.02-12.25-15.1-10.65-17.97 4.64-8.25 28.35-9.92 21.65.15Z"
      fill="#0F2A47"
    />
    <path
      d="M125.2 281.09c-.17-.07-9.4-4.21-10.47-3.86-1.08.36-2.43 3.66-2.43 3.66l16.25 3.67s-1.28-2.6-3.36-3.47Z"
      fill="#EA3B3B"
    />
    <path
      d="m182.63 325.83-51.71 48.75c-1.02.95-2.3 1.26-2.85.67l-1.74-1.86c-.55-.58-.17-1.84.84-2.8l51.72-48.74c1.01-.96 2.29-1.26 2.84-.68l1.75 1.86c.54.59.16 1.85-.85 2.8Z"
      fill="#1F4D84"
    />
    <path
      d="m153.6 353.19-22.68 21.39c-1.02.95-2.3 1.26-2.85.67l-1.74-1.86c-.55-.58-.17-1.84.84-2.8l22.7-21.38 3.74 3.98Z"
      fill="#739AF0"
    />
    <path
      d="M170.74 307.43a40.5 40.5 0 0 0 68.3 15.96 40.6 40.6 0 0 0-1.75-57.36 40.5 40.5 0 0 0-57.3 1.75 40.6 40.6 0 0 0-9.25 39.65Zm11.59-37.46a37.27 37.27 0 0 1 52.77-1.6 37.4 37.4 0 0 1-16.95 63.58 37.27 37.27 0 0 1-34.21-9.14 37.4 37.4 0 0 1-1.61-52.84Z"
      fill="#1F4D84"
    />
    <path
      opacity=".5"
      d="M236.7 321.2a37.27 37.27 0 0 1-52.77 1.61 37.4 37.4 0 0 1-1.6-52.84 37.27 37.27 0 0 1 52.77-1.6 37.4 37.4 0 0 1 1.6 52.82Z"
      fill="#B3CFF9"
    />
    <path
      d="M134.4 344.6c-28.49-20.32-26.12-47.45-26.12-47.45 10.41 5.88 20.75 18.89 25.5 30.17.27 6.45.5 12.7.63 17.29Z"
      fill="#EA3B3B"
    />
    <path
      d="M162.53 335.35c2-.47 3.36-1.99 3.64-2.25 0 0 .85.06-.14 1.89-.09.15-.27.54-.41.82-.06.12.02.25.15.26 1.16.09 2.32-.38 4.55.1.31.06.4.8.39 1.11-.02.53.02 1.13-.6 1.95-.36.47-1.36.98-3.6 1.89-.85.34-3.29.08-5.57-.7l-1.83-.85.57-3.4.46.1c.73.16 1.63-.73 2.39-.92Z"
      fill="#FFB27D"
    />
    <path
      d="M117.13 284.56s-25.6 4.88 7.53 42c5.3 5.94 33.93 13.67 33.93 13.67s2.9-2.48 1.44-4.48c0 0-19.72-14.33-24.05-16.6-1.95-1.03-7.57-22.88-10.76-28.14-3.18-5.27-8.1-6.45-8.1-6.45Z"
      fill="#FC5A5A"
    />
    <path
      d="M166.47 298.41s.84-1.6 1-2.45c.16-.84 1.22-3.3 1.65-3.74.17-.18.75.05.82.8.03.32-.13.91-.41 1.62-.46 1.15-.39 2.7-.55 3.22-.4 1.3-2.51.55-2.51.55ZM176.66 234.81c-.44.5-.5 1.06-.28 1.66.4 1.1 1.72 2.34 3.25 3.57a16.94 16.94 0 0 1 .64.54l.09.08c1.42 1.32.89 1.62 3.45 4.29 2.92 3.04 4.93 3.1 5.5 2.82.48-.24-.5-1.85-1.6-3.67l-.15-.26-.43-.73c-1.28-2.18-.95-3.2-.65-6.45.25-2.64 4.11-14.75 4.11-14.75l-5.6-.96s-1.69 9.64-3.54 11.12c-1 .8-2.1.8-3.06 1.39l-.2.12c-.54.36-1.1.73-1.53 1.23Z"
      fill="#FFB27D"
    />
    <path
      d="M176.66 234.81c-.44.5-.5 1.06-.28 1.66.5 1.1 1.78 2.33 3.25 3.56a14.24 14.24 0 0 1 .73.63c1.42 1.32.89 1.62 3.45 4.29 2.92 3.04 4.93 3.1 5.5 2.82.48-.24-.5-1.85-1.6-3.67-.56-.2-3.2-1.28-5.2-3.84-1.7-2.17-2.84-4.92-4-6.62l-.32-.06c-.54.36-1.1.73-1.53 1.23Z"
      fill="#0F2A47"
    />
    <path
      d="M221.8 231.33c.34 1.73 2.8 1.44 5.55.77 2.75-.68 2.1.13 6.02-.3 3.91-.44 5.1-1.9 5.22-2.48.1-.52-1.83-.7-3.9-.94l-.79-.1c-2.34-.3-4.06-1.8-6.19-3.05-2.01-1.18-5.02-5.98-5.02-5.98l-5.37.43s2.82 4.28 3.9 6.14c.65 1.1.61 2.55.53 3.67-.04.6-.08 1.23.04 1.84Z"
      fill="#FFB27D"
    />
    <path
      d="M227.35 232.1c2.75-.67 2.1.13 6.02-.3 3.91-.44 5.1-1.9 5.22-2.48.1-.52-1.83-.7-3.9-.94l-.02.04s-2.35 1.67-5.61 1.74c-2.66.07-5.47-.7-7.3-.67-.04.61-.09 1.23.04 1.84.34 1.73 2.8 1.44 5.55.77ZM201.22 196.94l-5.02 13.53-6.56 17.65s-1.78.17-3.48-.32a15.08 15.08 0 0 1-3.37-1.64s1.83-18.96 5.23-29.85c.87-2.79 1.84-5.05 2.92-6.32 5.26-6.22 10.28 6.95 10.28 6.95Z"
      fill="#0F2A47"
    />
    <path
      d="M196.13 175.46c-2.86-.92-10.32-.02-18.4 1.45a5.49 5.49 0 0 1-5.67-2.56l-20.35-1.6s-6.72 14.9-3.05 24.4c.54 1.4 1.72 2.28 3.56 2.3l16.23.03c10.12 0 21.42-6.96 22.89-7.25 2.39-.48 3.34 4.31 5.74 9.34 2.39 5.03 22.48 22.29 22.48 22.29s3.09.03 4.37-.45c1.37-.52 1.87-1.19 1.87-1.19s-22.26-44.36-29.67-46.76ZM169.92 114.5a7.22 7.22 0 0 0-3.89-1 10.9 10.9 0 0 1-1.87-.12c-7.77-1.14-12.45 10.15-12.73 13.56-.5 6.27-3.82 7.22-8.48 11.15-9.35 7.86-6.6 17-1.5 20.4 3.07 2.05 8.47.01 8.47.01.08.05 14.78-8.22 22.03-12.22 10.87-1.54 2.34-29.17-2.03-31.77Z"
      fill="#0F2A47"
    />
    <path
      d="M165.88 142.88c.03.02-3.57 1.25-5.97.18-2.27-1-3.98-4.73-3.95-4.73 1.03-.05 2.16-.95 3.04-6.86l.44.16 7.37 2.66s-.54 2.36-.89 4.62c-.29 1.89-.44 3.7-.04 3.97Z"
      fill="#FFB27D"
    />
    <path d="M166.8 134.28s-.3 1.28-.72 3.67c-4.23-.77-6.05-4.03-6.65-6.32l7.38 2.65Z" fill="#ED975D" />
    <path
      d="M167.9 136.63s-10.08-1.36-9.14-7.63c.94-6.27.27-10.68 6.75-10.07 6.48.6 7.37 3.18 7.57 5.35.19 2.17-2.53 12.55-5.18 12.35Z"
      fill="#FFB27D"
    />
    <path
      d="M172.7 120.84s-6.45 5.57-10.84 6.02c-4.4.45-6.06-.97-6.06-.97s2.6-2.14 4.15-5.62a3.08 3.08 0 0 1 2.55-1.82c3.14-.27 9.08-.4 10.2 2.4Z"
      fill="#0F2A47"
    />
    <path
      d="M168.67 120.34s2.16 2.1 2.84 3.65c.66 1.5.85 5.07.33 6.5 0 0 3.37-6.56 1.46-9.74-2.02-3.38-4.63-.4-4.63-.4Z"
      fill="#0F2A47"
    />
    <path
      d="M174.36 157.76c-.3 20.43-.09 16.16-2.32 18.1-.54.47-2.05.75-4.04.88-6.26.41-17.27-.62-17.68-1.78-1.45-4.01-.43-5.25-1.63-11.39-.12-.65-.28-1.36-.46-2.13-1-4.21-1.98-5.65 1.59-12.41 3.23-6.14 6.59-11.11 6.89-10.93 8.53 5.07 9.21.8 9.21.8s8.6 8.89 8.44 18.86Z"
      fill="#FC5A5A"
    />
    <path
      d="m196.2 210.47-6.56 17.65s-1.78.17-3.48-.32a15.08 15.08 0 0 1-3.37-1.64s1.83-18.96 5.23-29.85l8.18 14.16Z"
      fill="#0F2A47"
    />
    <path
      d="M165.92 138.9s8.78 1.5 9.8 5.28c1.03 3.78 4.42 26.74 4.42 26.74s-2.48 2.42-4.54.35c-2.06-2.06-6.47-21.48-6.47-21.48l-3.2-10.88Z"
      fill="#FC5A5A"
    />
    <path
      d="M168 176.74c-6.26.41-17.26-.62-17.68-1.78-1.44-4.01-.42-5.25-1.63-11.39l3.03-8.51s-.5 9.48 2.29 11.97c2.78 2.5 11.43 4.82 12.78 6.9.66 1 1.09 2 1.21 2.8Z"
      fill="#EA3B3B"
    />
    <path
      d="M160.83 172.75s6.17-1.38 7.17-.83c1 .55 3.43 2.55 3.74 3.25.3.7-2.22-.53-3.04-.75-.53-.15-1.93.34-2.63.57-2.91.97-4.7.47-4.7.47l-.54-2.71Z"
      fill="#FFB27D"
    />
    <path
      d="M156.7 138.1s-8.29.5-11.16 4.5c-4.04 5.65-12.07 29.7-7.48 32.9 5.18 3.62 23.55.96 23.55.96s.61-2.87-.24-4.25-14.67-3.62-15.31-4.26c-.64-.64 7.98-12.46 7.98-14.38 0-1.91 2.66-15.48 2.66-15.48Z"
      fill="#FC5A5A"
    />
    <path
      d="M168.3 173.65s1.3 1.67 1.72 1.86c.42.2.7.15.7.15l-.87-1.57-1.55-.44ZM168 171.92l3.76 1.83s-.16.27-.62.25a9 9 0 0 1-1.63-.46l-1.5-1.62Z"
      fill="#FFB27D"
    />
    <path d="m200.13 176.23-39.3-.01v.87l38.95.01.35-.87Z" fill="#0F2A47" />
    <path d="M170.02 177.1h29.76l8.96-22.28-29.72-.01-9 22.28Z" fill="#0F2A47" />
    <path
      d="M192.27 165.96c.23-.79-.23-1.42-1.01-1.42s-1.6.63-1.82 1.41c-.23.79.22 1.42 1 1.42.79 0 1.6-.63 1.83-1.41Z"
      fill="#fff"
    />
    <path
      d="M393.68 261.14c-4-1.33-6.78.35-6.78.35-11.54.48-11.97 12.32-10.62 16.73 1.9 6.2-4.83 11.07 2.64 13.58 8.66 2.9 15.94-.54 15.44.96 27.4 2.16 8.44-28.59-.68-31.62Z"
      fill="#0F2A47"
    />
    <path
      d="M381.7 318.76s-1.09 2.17-3.08 4.67c-2.4 3-14.98-4.13-13.9-4.67 1.09-.55 7.41-18.79 8.92-21.08 1.5-2.3 6.64-3.48 6.64-3.48l1.43 24.56Z"
      fill="#FC5A5A"
    />
    <path
      d="M424.18 441.78s3.47 3.18 2.8 5.43c-.68 2.26-3.82 3.76-4.24 6.52-.42 2.75-2.12 4.26-3.64 4.26h-7.28s-1.12-1.94 1.6-2.53c2.7-.58 3.73-3.82 3.56-6.83-.17-3 .25-7.01.25-7.01l5.76-1.34 1.2 1.5Z"
      fill="#1F447F"
    />
    <path
      d="M394.78 443.13s1.25 13.45-.27 14.2l-19.52-.04s0-2.26 3.13-2.76c3.14-.5 8.65-2.34 9.58-6.43.93-4.09 7.08-4.97 7.08-4.97Z"
      fill="#1C3154"
    />
    <path
      d="M409.8 309.69s.28 4.1 0 9.03c-.2 3.26-3.5 7.64-3.97 8.72-1.17 2.71-2.5 3.15-2.5 3.15l-10.24 2.52-3.6.88-11.37-3.4s-5.18-14.46-3.1-22.6c2.08-8.14 5.25-13.8 5.25-13.8s7.73-1.73 21.35-.77l8.17 16.27Z"
      fill="#FC5A5A"
    />
    <path
      d="M410.77 318.83c-.2 3.27-4.47 7.53-4.94 8.61-1.17 2.71-2.5 3.15-2.5 3.15l-10.24 2.52-1.85-5.31s14.97-3.94 12.56-17.81l6.97 8.84Z"
      fill="#EA3B3B"
    />
    <path
      d="M378.84 332.79s-5.62 17.53-5.99 23.5c-.36 5.97 10.76 84.81 11.2 87.56.43 2.6 3.64 4.25 3.64 4.25s1.49.88 3.6.28c2.92-.83 3.85-1.82 3.85-1.82s4.38-56.23 1.67-76.31c-2.71-20.09-2.74-37.46-2.74-37.46h-15.23Z"
      fill="#0F2A47"
    />
    <path
      d="M402.69 332.27s8.58 11.53 9.38 19.32c.8 7.8 1.25 35.17 2.96 42.77 1.7 7.6 7.97 22.22 7.97 45.92 0 0-.65 1.36-2.66 2.08-.64.23-1.5.46-2.34.65a3.68 3.68 0 0 1-4.12-1.95c-4.23-8.54-17.72-36.07-18.41-41.78-.5-4.05-4.75-30.81-14.04-46.52C379.19 349 382.8 334 382.8 334l19.88-1.73Z"
      fill="#0F2A47"
    />
    <path
      d="M377.94 330.08s2.26 1.8 6.75 1.88c5.36.11 18.64-1.37 18.64-1.37s.6 1.66.57 3.4c0 0-16.22 4.1-25.62.6 0 0-1.21-2.28-.33-4.5Z"
      fill="#0F2A47"
    />
    <path
      d="M383.4 336.59c-1.34 0-2.44-1.24-2.44-2.77s1.1-2.77 2.45-2.77c1.34 0 2.44 1.24 2.44 2.77s-1.1 2.77-2.44 2.77Zm0-4.73c-.9 0-1.63.88-1.63 1.96s.74 1.96 1.64 1.96c.9 0 1.63-.88 1.63-1.96s-.73-1.96-1.63-1.96Z"
      fill="#fff"
    />
    <path d="m395.13 341.63-24.39.23-12-28.23 24.39-.23 12 28.23Z" fill="#B5453C" />
    <path
      d="m391.94 328.87-1.8-2.2s-1.2-1.08-2.08-1.26c-.88-.18-2.73-1.25-2.9-.95-.19.3 1.42 2.45 1.42 2.45l.08.01c-1.84 1.39-6.5.16-7.06.73-.7.68.95 2.17 1.84 3 .89.83 3.42 2.22 5.4 1.6 1.44-.45 3.72-.9 3.72-.9l1.38-2.48ZM360.58 318.6s1.53-1.75 2.5-.91c.98.83-.25 4.95-1.18 4.53-.93-.42-1.85-3.11-1.32-3.62Z"
      fill="#FFB27D"
    />
    <path
      d="M401.62 293.43s6.98.77 11.99 9.88c3.95 7.19 10.7 20.43 8.15 24.17-1.11 1.64-11.84 7.49-32.52 4.15 0 0 .33-2.62 2-3.83 0 0 17.4-5.6 17.37-6.7-.06-2.11-2.35-3.93-12.07-13.67-2.65-2.64 5.08-14 5.08-14Z"
      fill="#FC5A5A"
    />
    <path
      d="M396.25 293.8c.24-.32-.07-1.35-.45-3.26-.35-1.73-.94-4.41-.93-7.43l-.51.09-8.65 1.46s.2 2.31.2 4.5v.05c.01 1.9-.5 4.76.13 5.13 3.28 1.92 9.29.7 10.21-.54Z"
      fill="#FFB27D"
    />
    <path d="M385.7 284.65s.18 3.27.19 5.45c4.84-.12 7.42-4.82 8.47-6.9l-8.65 1.45Z" fill="#E8945B" />
    <path
      d="M385.19 288.55s11.34-1.62 10.22-8.67c-1.11-7.06-.4-12.02-7.69-11.28-7.29.73-8.26 3.65-8.46 6.1-.2 2.44 2.95 14.09 5.93 13.85Z"
      fill="#FFB27D"
    />
    <path
      d="M382.54 269.25s4.42 7.78 9.36 8.24c4.95.47 6.81-1.13 6.81-1.13s-4.1-2.32-5.67-7.26c0 0-8.79-4.16-10.5.15Z"
      fill="#0F2A47"
    />
    <path
      d="M383.42 269.8s-2.16 1.22-2.84 3.05a11.55 11.55 0 0 0-.5 6.72s-3.23-5.25-1.11-8.85c2.24-3.82 4.45-.93 4.45-.93Z"
      fill="#163560"
    />
    <path
      d="M633.27 459H4.65a.79.79 0 0 1-.79-.79v-.45c0-.43.36-.79.79-.79h628.62c.43 0 .78.35.78.79v.45c0 .44-.35.79-.78.79Z"
      fill="#0F2A47"
    />
  </svg>
  <a class="returnToButton" [href]="redirectUrl">{{ redirectLabel }}</a>
</section>
